import { render } from "./CardPolicyBase.vue?vue&type=template&id=94972682&scoped=true"
import script from "./CardPolicyBase.vue?vue&type=script&lang=js"
export * from "./CardPolicyBase.vue?vue&type=script&lang=js"

import "./CardPolicyBase.vue?vue&type=style&index=0&id=94972682&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94972682"]])

export default __exports__